import { createRouter, RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'
import { rootRoute } from './root.tsx'
import { currentlyOutRoute } from './pages/in_cinemas_page.tsx'
import { upcomingRoute } from './pages/upcoming.tsx'
import { movieInfoRoute } from './pages/movie_info.tsx'
import { savedMoviesRoute } from './pages/saved_movies.tsx'


const router = createRouter({
  routeTree: rootRoute.addChildren([
    currentlyOutRoute,
    upcomingRoute,
    movieInfoRoute,
    savedMoviesRoute,
  ]),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement)
  root.render(<RouterProvider router={router}/>)
}

if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/serviceWorker.js', {scope: '/'})
}

if (matchMedia('(display-mode: standalone)').matches) {
  const notificationPermission = await Notification.requestPermission()
  const { state: periodicSyncPermission } = await navigator.permissions.query({ name: 'periodic-background-sync' as any })
  if (notificationPermission === 'granted' && periodicSyncPermission === 'granted') {
    const swRegistration = await navigator.serviceWorker.ready;
    (swRegistration as any).periodicSync.register("check-new-movies", { minInterval: 24 * 60 * 60 * 1000, });
  }
}
